import { useState } from "react";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import { dataValidator } from "../../tools/dataValidator";
import reportApi from "../../api/reportApi";

import { getLabel, getLanguage } from "../../tools/Dictionary";

const ProcessReport = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const Product = props.Product;
  const Process = props.Process;
  const Step = props.Step;
  const Path = props.Path;
  const Value = props.Value;
  const OnCloseModal = props.OnCloseModal;

  //State
  const [form, setForm] = useState({
    issue: ""
  });
  const [error, setError] = useState({

  });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  const onChangeIssue = (e) => {

    let issue = e.target.value;

    onValidateField("issue", issue); //Validate field value

    setForm(form => ({
      ...form,
      issue
    }));

  };

  // Validate field
  const onValidateField = (field = "", value = "") =>
  {
    let currentError = { ...error }; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];
    let currentField = "";

    let isValid = true; // Flag to track overall validity

    currentField = "issue";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:1000"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag
  };

  const onClickSend = async() => {

    if (!onValidateField())
    {

      return;
    }

    try
    {

      setLoading(true);

      let currentPath = []//_.cloneDeep(Path);

      Path.forEach(p =>
      {

        let tempPath = {
          id: p._id,
          title: p.title,
          component: []
        };

        tempPath.component = Value.filter(v => v.step == p._id).map(v => ({
          _id: v.component,
          title: p.title,
          value: v.data,
          parameter: v.parameter
        }));


        currentPath.push(tempPath);

      });

      currentPath = currentPath.filter(p => p.component.length > 0);


      let parameters = {
        _id: 0,
        process: Process._id,
        product: Product._id,
        path: currentPath,
        step: Step._id,
        description: form.issue
      };

      let response = await reportApi.updateReport(parameters);

      if (!response.Success)
      {


        let error = new Error()
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label, response.Error.parameter) : undefined;

        throw error;

      }

      setLoading(false);

      OnCloseModal();


    } catch (err)
    {

      setLoading(false);


      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      throw err;

    };
  };
 

  return (
    <div className="page_modal_background" style={{zIndex: 200}}>
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ProcessReport", "Report an issue")}
        </div>
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ProcessReport", "Product")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className={"page_text_input"}
                value={Product.label[getLanguage().code] || Product.label["EN"] || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ProcessReport", "Issue")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <textarea
                className={"page_textarea_input " + (error["issue"] ? "page_modal_body_col_input_error" : "")}
                rows={10}
                value={form.issue || ""}
                onChange={onChangeIssue}
                type="text"
                style={{ width: "100%" }}
                disabled={loading}
                autoFocus={true}
              />
              {error["issue"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["issue"]}
                </div>
              }
            </div>
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("ProcessReport", "Send")}
            style={{ maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : onClickSend}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default ProcessReport